module.exports = __webpack_public_path__ + "static/media/delivery-icon.e0e744cd.webp";